import React from 'react'
import { Link } from 'react-router-dom'

export default function Error404() {
  return (
    <div className="flex min-h-[70vh] flex-col items-center justify-center px-4 py-16 text-center bg-gray-50">
      <div className="max-w-md space-y-6">
        <div className="relative mx-auto flex h-24 w-24 items-center justify-center rounded-full bg-brand-red/10 text-brand-red">
          <i className="fa-regular fa-tractor-broken text-5xl animate-bounce" />
        </div>
        <h1 className="text-6xl font-extrabold text-gray-900 font-display">404</h1>
        <h2 className="text-2xl font-bold text-gray-800 font-display">Siden blev ikke fundet</h2>
        <p className="text-gray-500 text-sm leading-relaxed">
          Beklager, men den side du leder efter findes ikke eller er blevet flyttet. Gå tilbage til forsiden for at finde vej.
        </p>
        <div className="pt-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-xl bg-brand-red px-6 py-3.5 text-sm font-bold text-white shadow-md hover:bg-brand-red-hover transition-colors cursor-pointer"
          >
            <i className="fa-regular fa-house" />
            Gå til forsiden
          </Link>
        </div>
      </div>
    </div>
  )
}
